module.exports = __webpack_public_path__ + "static/Service-hero-7142e796f936ef2cde75de1969fe80d5.png";